import {
  Button,
  Checkbox,
  Drawer,
  Form,
  Input,
  notification,
  Select,
  Spin,
} from "antd";
import { NotificationPlacement } from "antd/lib/notification";
import React, { useState } from "react";
import CityService, { CargoType } from "../../../service/CityService";

function AddCity({ openData, setOpenData }: any) {
  const [loading, setLoading] = useState(false);
  const openNotification = (placement: NotificationPlacement) => {
    notification.success({
      message: `Success`,
      description: "添加成功",
      placement,
    });
  };
  const onFinish = async (values: any) => {
    setLoading(true);
    await CityService.add({
      ...values,
      isMain: values.isMain === true ? true : false,
    });
    openNotification("topRight");
    setLoading(false);
  };
  const keys1 = Object.keys(CargoType);
  const onClose = () => {
    setOpenData(false);
  };
  return (
    <Drawer
      title="添加分部"
      placement="right"
      onClose={onClose}
      open={openData}
    >
      <Spin spinning={loading} size="large">
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item label="名称kz" name="titleKZ" required>
            <Input />
          </Form.Item>

          <Form.Item label="名称RU" name="titleRU" required>
            <Input />
          </Form.Item>

          <Form.Item label="名称CN" name="titleCN" required>
            <Input />
          </Form.Item>

          <Form.Item label="备注" name="shortTitle" required>
            <Input />
          </Form.Item>

          <Form.Item
            label="主分部"
            name="isMain"
            valuePropName="checked"
            wrapperCol={{ offset: 8, span: 16 }}
          >
            <Checkbox>主分部</Checkbox>
          </Form.Item>

          <Form.Item
            wrapperCol={{ offset: 8, span: 16 }}

            // wrapperCol={{ offset: 8, span: 16 }}
          >
            <Button type="primary" htmlType="submit">
              添加
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Drawer>
  );
}

export default AddCity;
